module.exports = __webpack_public_path__ + "img/img_placeholder_HTSi.c605107d.svg";